export default "__VITE_ASSET__C6zuZWr4__";